export const WomanGender = () => {
  return (
    <svg
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M25.0594 19.2937C26.9438 17.4094 27.9844 14.8992 27.9844 12.2344C27.9844 9.56602 26.9473 7.05937 25.0594 5.175C23.175 3.29062 20.6648 2.25 18 2.25C15.3352 2.25 12.825 3.28711 10.9406 5.175C9.05625 7.06289 8.01562 9.56602 8.01562 12.2344C8.01562 14.4773 8.75039 16.6078 10.1039 18.348C10.3605 18.6785 10.6383 18.9914 10.9371 19.2937C11.2359 19.5926 11.5523 19.8703 11.8793 20.127C13.2715 21.2098 14.9133 21.8988 16.6641 22.1309V25.875H12.6562C12.5016 25.875 12.375 26.0016 12.375 26.1562V28.2656C12.375 28.4203 12.5016 28.5469 12.6562 28.5469H16.6641V33.4688C16.6641 33.6234 16.7906 33.75 16.9453 33.75H19.0547C19.2094 33.75 19.3359 33.6234 19.3359 33.4688V28.5469H23.3438C23.4984 28.5469 23.625 28.4203 23.625 28.2656V26.1562C23.625 26.0016 23.4984 25.875 23.3438 25.875H19.3359V22.1309C21.498 21.8426 23.4914 20.8617 25.0594 19.2937ZM18 19.5469C16.0453 19.5469 14.2137 18.7875 12.8285 17.4059C11.4469 16.0242 10.6875 14.1891 10.6875 12.2344C10.6875 10.2797 11.4469 8.44805 12.8285 7.06289C14.2102 5.67773 16.0453 4.92188 18 4.92188C19.9547 4.92188 21.7863 5.68125 23.1715 7.06289C24.5531 8.44453 25.3125 10.2797 25.3125 12.2344C25.3125 14.1891 24.5531 16.0207 23.1715 17.4059C21.7863 18.7875 19.9547 19.5469 18 19.5469Z'
        fill='white'
        fillOpacity='0.45'
      />
    </svg>
  );
};
